import { useYMapEntries } from './useYMapEntries';
import { yMeta } from '../schema';
import { getDiagramDoc } from '../doc';

export function useMeta() {
    const doc = getDiagramDoc();
    return useYMapEntries(doc ? yMeta(doc) : null);
}
